// Système de mémorisation des fichiers pour la navigation entre étapes
let savedFileData = {};

// Variable pour mémoriser l'état du ZIP
let zipExists = false;

const FILE_CONFIG = {
  acceptedTypes: '.pdf,.jpg,.jpeg,.png,.bmp,.tiff',
  fileInputClass: 'js-fichier',
  classes: {
    group: 'groupe-champs',
    required: 'required',
    button: 'button alt js-file-button',
    fileName: 'file-name js-file-name'
  },
  labels: {
    schema: 'Schéma unifilaire de l\'installation envisagée',
    onduleur: 'Preuve de certifications obtenues',
    chooseFile: 'Choisir un fichier',
    modifyFile: 'Modifier le fichier'
  }
};

const ZIP_CONFIG = {
  selectors: {
    loader: '.js-zip-loader',
    createButton: '.js-create-zip',
    deleteButton: '.js-delete-zip',
    zipInput: '#fj-fichier-1',
    zipSummary: '#zip-summary',
    zipFileList: '#zip-file-list',
    zipFileSize: '#zip-file-size',
    filesStatus: '.js-files-status',
    submitButton: '.btn-submit-sub',
    fileInputs: '.js-fichier'
  },
  classes: {
    container: 'js-zip-loader spinner-loader',
    spinner: 'spinner',
    statusError: 'js-files-status files-status error',
    statusSuccess: 'js-files-status files-status success',
    statusInfo: 'js-files-status files-status info'
  },
  limits: {
    maxSizeBytes: 20 * 1024 * 1024 // 20 Mo
  },
  text: 'Création du fichier ZIP en cours...',
  zipFileName: 'fichiers_joint.zip'
};

function createCustomFileInput(id, name, className, accept, isRequired = true) {
  // Créer l'input file natif (masqué)
  const fileInput = document.createElement('input');
  fileInput.type = 'file';
  fileInput.id = id;
  fileInput.name = name;
  fileInput.className = className;
  fileInput.accept = accept;
  fileInput.style.display = 'none';

  if (isRequired) {
    fileInput.setAttribute('required', 'required');
    fileInput.setAttribute('aria-required', 'true');
  }

  // Créer le bouton personnalisé
  const fileButton = document.createElement('button');
  fileButton.type = 'button';
  fileButton.className = FILE_CONFIG.classes.button;
  fileButton.textContent = FILE_CONFIG.labels.chooseFile;

  // Appliquer l'état disabled si un ZIP existe
  if (zipExists) {
    fileButton.disabled = true;
  }

  // Créer le span pour le nom du fichier
  const fileName = document.createElement('span');
  fileName.className = FILE_CONFIG.classes.fileName;

  function handleFileChange() {
    const hasFile = this.files.length > 0;

    if (!hasFile) {
      fileName.textContent = '';
      fileButton.textContent = FILE_CONFIG.labels.chooseFile; // ✅ Unifié
      return;
    }

    fileName.textContent = this.files[0].name;
    fileButton.textContent = FILE_CONFIG.labels.modifyFile; // ✅ Unifié
  }

  fileButton.addEventListener('click', () => fileInput.click());
  fileInput.addEventListener('change', handleFileChange);

  return { fileInput, fileButton, fileName };
}

function createFileUploadGroup(config) {
  const { id, name, label } = config;

  const group = document.createElement('div');
  group.className = FILE_CONFIG.classes.group; // ✅ Unifié

  const labelElement = createLabel(id, label);
  const { fileInput, fileButton, fileName } = createCustomFileInput(
    id, name, FILE_CONFIG.fileInputClass, FILE_CONFIG.acceptedTypes, true // ✅ Unifié
  );

  restoreFileIfExists(name, fileInput, fileName, fileButton);

  group.appendChild(labelElement);
  group.appendChild(fileInput);
  group.appendChild(fileButton);
  group.appendChild(fileName);

  return group;
}

function createLabel(htmlFor, textContent) {
  const label = document.createElement('label');
  label.htmlFor = htmlFor;
  label.className = FILE_CONFIG.classes.required;
  label.textContent = textContent;
  return label;
}

function restoreFileIfExists(name, fileInput, fileName, fileButton) {
  const savedFile = savedFileData[name];
  if (!savedFile) return;

  const dataTransfer = new DataTransfer();
  dataTransfer.items.add(savedFile);
  fileInput.files = dataTransfer.files;
  fileName.textContent = savedFile.name;
  fileButton.textContent = FILE_CONFIG.labels.modifyFile;
}

function setupFileUploads() {
  const fileContainer = document.querySelector('.js-fichiers-container');
  if (!fileContainer) return;

  fileContainer.innerHTML = '';

  // Orchestrer la création des champs
  createSchemaFileField(fileContainer);
  createOnduleurFileFields(fileContainer);
  setupFileSaveListeners();

  // Important : Mettre à jour les états des boutons APRÈS la création des fichiers
  setTimeout(() => {
    updateZipButtonStates();
  }, 50);
}

function createSchemaFileField(container) {
  const schemaConfig = {
    id: 'fichier-schema',
    name: 'fichier-schema',
    label: FILE_CONFIG.labels.schema
  };

  const schemaGroup = createFileUploadGroup(schemaConfig);
  container.appendChild(schemaGroup);
}

function createOnduleurFileFields(container) {
  const hasOnduleurs = isOnduleurRequired();
  if (!hasOnduleurs) return;

  const onduleurs = getActiveOnduleurList();

  if (onduleurs.length === 0) {
    createDefaultOnduleurField(container);
    return;
  }

  onduleurs.forEach((onduleur, index) => {
    const onduleurGroup = createOnduleurFileGroup(onduleur, index + 1);
    container.appendChild(onduleurGroup);
  });
}

function isOnduleurRequired() {
  const onduleurOui = document.getElementById('onduleur-oui');
  return onduleurOui && onduleurOui.checked;
}

function getActiveOnduleurList() {
  const onduleurs = [];

  // Ajouter l'onduleur de base s'il est visible
  const baseOnduleur = getBaseOnduleur();
  if (baseOnduleur) {
    onduleurs.push(baseOnduleur);
  }

  // Ajouter les onduleurs supplémentaires actifs
  const additionalOnduleurs = getAdditionalOnduleurs();
  onduleurs.push(...additionalOnduleurs);

  return onduleurs;
}

function getBaseOnduleur() {
  const baseElement = document.querySelector('#template-onduleur');
  if (!baseElement || baseElement.style.display === 'none') return null;

  return {
    element: baseElement,
    fabricant: document.getElementById('fabricant-onduleur')?.value || '',
    modele: document.getElementById('modele-onduleur')?.value || ''
  };
}

function getAdditionalOnduleurs() {
  const onduleurBlocs = document.querySelectorAll('.js-onduleur');
  const additionalOnduleurs = [];

  onduleurBlocs.forEach(bloc => {
    // Skip l'onduleur de base
    if (bloc.id === 'template-onduleur') return;

    // Skip les blocs inactifs
    if (!isOnduleurBlockActive(bloc)) return;

    additionalOnduleurs.push({
      element: bloc,
      fabricant: bloc.querySelector('[name^="fabricant_onduleur"]')?.value || '',
      modele: bloc.querySelector('[name^="modele_onduleur"]')?.value || ''
    });
  });

  return additionalOnduleurs;
}

function isOnduleurBlockActive(bloc) {
  return !bloc.classList.contains('deleted') &&
         window.getComputedStyle(bloc).display !== 'none';
}

function createFileUploadGroup(config) {
  const { id, name, label } = config;

  // Créer le fragment
  const fragment = document.createDocumentFragment();

  const group = document.createElement('div');
  group.className = FILE_CONFIG.classes.group;

  const labelElement = createLabel(id, label);
  const { fileInput, fileButton, fileName } = createCustomFileInput(
    id, name, FILE_CONFIG.fileInputClass, FILE_CONFIG.acceptedTypes, true
  );

  // Restaurer le fichier sauvegardé
  restoreFileIfExists(name, fileInput, fileName, fileButton);

  // Ajouter tout au groupe en une fois
  group.append(labelElement, fileInput, fileButton, fileName);
  fragment.appendChild(group);

  return fragment;
}

function createOnduleurFileGroup(onduleur, count) {
  const id = `fichier-onduleur-${count}`;
  const name = `fichier-onduleur-${count}`;
  let label = `${FILE_CONFIG.labels.onduleur}`;

  if (onduleur.fabricant && onduleur.modele) {
    label += ` (${onduleur.fabricant} - ${onduleur.modele})`;
  }

  return createFileUploadGroup({ id, name, label });
}

function createDefaultOnduleurField(container) {
  const defaultConfig = {
    id: 'fichier-onduleur-1',
    name: 'fichier-onduleur-1',
    label: `Onduleur 1: ${FILE_CONFIG.labels.onduleur}`
  };

  const defaultGroup = createFileUploadGroup(defaultConfig);
  container.appendChild(defaultGroup);
}

function createLabel(htmlFor, textContent) {
  const label = document.createElement('label');
  label.htmlFor = htmlFor;
  label.className = FILE_CONFIG.classes.required;
  label.textContent = textContent;
  return label;
}

function restoreFileIfExists(name, fileInput, fileName, fileButton) {
  const savedFile = savedFileData[name];
  if (!savedFile) return;

  const dataTransfer = new DataTransfer();
  dataTransfer.items.add(savedFile);
  fileInput.files = dataTransfer.files;
  fileName.textContent = savedFile.name;
  fileButton.textContent = FILE_CONFIG.labels.modifyFile;
}

function setupFileSaveListeners() {
  const fileInputs = document.querySelectorAll('.js-fichier');

  fileInputs.forEach(input => {
    // Éviter les doublons d'événements
    input.removeEventListener('change', handleFileChange);
    input.addEventListener('change', handleFileChange);
  });
}

// Handler séparé et réutilisable
function handleFileChange() {
  const hasFile = this.files.length > 0;

  if (!hasFile) {
    delete savedFileData[this.name];
    return;
  }

  savedFileData[this.name] = this.files[0];
}

function createElementWithText(tag, className, textContent) {
  const element = document.createElement(tag);
  element.className = className;
  if (textContent) element.textContent = textContent;
  return element;
}

// Version ultra-concise
function createZipLoader() {
  const container = createElementWithText('div', ZIP_CONFIG.classes.container);
  const spinner = createElementWithText('div', ZIP_CONFIG.classes.spinner);
  const text = createElementWithText('span', '', ZIP_CONFIG.text);

  container.append(spinner, text);
  return container;
}

function removeExistingZipLoader() {
  const existingLoader = document.querySelector(ZIP_CONFIG.selectors.loader);
  existingLoader?.remove(); // Optional chaining
}

function showZipLoader() {
  const createZipButton = document.querySelector(ZIP_CONFIG.selectors.createButton);
  if (!createZipButton) return;

  // Early return si un loader existe déjà
  const existingLoader = document.querySelector(ZIP_CONFIG.selectors.loader);
  if (existingLoader) return;

  const loader = createZipLoader();
  createZipButton.parentNode.insertBefore(loader, createZipButton.nextSibling);
}

function hideZipLoader() {
  const loader = document.querySelector(ZIP_CONFIG.selectors.loader);
  if (loader) {
    loader.remove();
  }
}

function updateZipButtonStates() {
  const zipInput = document.querySelector('#fj-fichier-1');
  const createZipButton = document.querySelector('.js-create-zip');
  const deleteZipButton = document.querySelector('.js-delete-zip');
  const containerFileButton = document.querySelector('.js-fichiers-container');

  if (!zipInput || !createZipButton || !deleteZipButton || !containerFileButton) return;

  const allFilesButtons = containerFileButton.querySelectorAll('.js-file-button');

  // Mettre à jour la variable globale de l'état du ZIP
  zipExists = zipInput.files.length > 0;

  // Gérer la note d'information
  let infoNote = document.querySelector('.js-zip-info-note');

  if (zipExists) {
    // ZIP exists - disable create button and show delete button
    createZipButton.disabled = true;
    allFilesButtons.forEach(element => {
      element.disabled = true;
    });
    deleteZipButton.style.display = 'inline-block';
    document.querySelector('#zip-summary').style.display = 'block';

    // Ajouter la note d'information si elle n'existe pas
    if (!infoNote) {
      infoNote = document.createElement('div');
      infoNote.className = 'js-zip-info-note zip-info-note';
      infoNote.textContent = 'Pour modifier le fichier, veuillez supprimer le fichier et en créer un nouveau.';
      createZipButton.parentNode.insertBefore(infoNote, createZipButton.nextSibling);
    }
    infoNote.style.display = 'block';
  } else {
    // No ZIP - enable create button and hide delete button
    createZipButton.disabled = false;
    allFilesButtons.forEach(element => {
      element.disabled = false;
    });
    deleteZipButton.style.display = 'none';
    document.querySelector('#zip-summary').style.display = 'none';

    // Masquer la note d'information
    if (infoNote) {
      infoNote.style.display = 'none';
    }
  }
}

function initializeFileManager() {
  // Check if we're on step 6
  const step6 = document.getElementById('etape-6');
  if (!step6 || window.getComputedStyle(step6).display === 'none') return;

  // Create a container for file uploads if it doesn't exist
  let fileContainer = document.querySelector('.js-fichiers-container');
  if (!fileContainer) {
    fileContainer = document.createElement('div');
    fileContainer.className = 'js-fichiers-container';

    const fileSection = document.createElement('div');
    fileSection.className = 'bloc-section';
    fileSection.innerHTML = '<h3 class="h4">Fichiers à joindre</h3>';
    fileSection.appendChild(fileContainer);

    // Add the section to step 6
    step6.appendChild(fileSection);
  }

  // Setup everything
  setupFileUploads();
  setupZipHandlers();
  setupOnduleurChangeListeners();

  // Update button states in case ZIP already exists
  updateZipButtonStates();
}

function setupZipHandlers() {
  attachCreateZipHandler();
  attachDeleteZipHandler();
}

function attachCreateZipHandler() {
  document.querySelector(ZIP_CONFIG.selectors.createButton)?.addEventListener('click', handleCreateZip);
}

function attachDeleteZipHandler() {
  document.querySelector(ZIP_CONFIG.selectors.deleteButton)?.addEventListener('click', handleDeleteZip);
}

async function handleCreateZip() {
  const context = initializeZipCreationContext();

  if (context.isModifying) {
    clearExistingZip();
  }

  // 1. Valider les fichiers requis
  const validationResult = validateRequiredFiles();
  if (!validationResult.isValid) {
    showStatusMessage(validationResult.errorMessage, 'error');
    return;
  }

  // 2. ✅ NOUVEAU : Valider les types de fichiers
  const typeValidation = validateFileTypes();
  if (!typeValidation.isValid) {
    showStatusMessage(typeValidation.errorMessage, 'error');
    return;
  }

  showZipLoader();
  disableCreateButton();

  try {
    const zipResult = await processFilesToZip();
    if (!zipResult.isValid) {
      showStatusMessage(zipResult.errorMessage, 'error');
      return;
    }
    finalizeZipCreation(zipResult, context.isModifying);
  } catch (error) {
    showStatusMessage('Erreur technique lors de la création du ZIP.', 'error');
  } finally {
    hideZipLoader();
    enableCreateButton();
  }
}

function initializeZipCreationContext() {
  const zipInput = document.querySelector(ZIP_CONFIG.selectors.zipInput);
  return {
    isModifying: zipInput.files.length > 0,
    zipInput
  };
}

function clearExistingZip() {
  const zipInput = document.querySelector(ZIP_CONFIG.selectors.zipInput);
  const summary = document.querySelector(ZIP_CONFIG.selectors.zipSummary);
  const fileList = document.querySelector(ZIP_CONFIG.selectors.zipFileList);
  const fileSize = document.querySelector(ZIP_CONFIG.selectors.zipFileSize);

  zipInput.value = '';
  summary.style.display = 'none';
  fileList.innerHTML = '';
  fileSize.textContent = '';

  // Mettre à jour la variable globale
  zipExists = false;
}

function validateRequiredFiles() {
  const fileInputs = document.querySelectorAll(ZIP_CONFIG.selectors.fileInputs);
  const emptyFields = [];

  fileInputs.forEach(input => {
    if (!input.files[0]) {
      emptyFields.push(input.previousElementSibling.textContent.trim());
    }
  });

  if (emptyFields.length > 0) {
    return {
      isValid: false,
      errorMessage: `Erreur : Veuillez sélectionner tous les fichiers requis avant de créer le ZIP. Champs manquants: ${emptyFields.join(', ')}`
    };
  }

  return { isValid: true };
}

async function processFilesToZip() {
  const zip = new JSZip();
  const fileInputs = document.querySelectorAll(ZIP_CONFIG.selectors.fileInputs);
  const fileList = document.querySelector(ZIP_CONFIG.selectors.zipFileList);

  fileList.innerHTML = '';
  let totalSize = 0;

  fileInputs.forEach((fileInput, index) => {
    const file = fileInput.files[0];
    if (!file) return;

    const newFileName = generateZipFileName(file, index);
    zip.file(newFileName, file);

    totalSize += file.size;
    addFileToDisplayList(file, fileList);
  });

  // Vérifier la taille totale
  if (totalSize > ZIP_CONFIG.limits.maxSizeBytes) {
    return {
      isValid: false,
      errorMessage: 'Erreur : Le poids total des fichiers dépasse 20 Mo. Veuillez réduire la taille des fichiers sélectionnés.'
    };
  }

  const zipBlob = await zip.generateAsync({ type: 'blob' });
  return {
    isValid: true,
    zipBlob,
    totalSize
  };
}

function generateZipFileName(file, index) {
  const extension = file.name.split('.').pop();
  return index === 0
    ? `schema-unifilaire.${extension}`
    : `certification-onduleur-${index}.${extension}`;
}

function addFileToDisplayList(file, fileList) {
  const listItem = document.createElement('li');
  listItem.textContent = `${file.name} (${(file.size / 1024 / 1024).toFixed(2)} Mo)`;
  fileList.appendChild(listItem);
}

function finalizeZipCreation(zipResult, isModifying) {
  const zipInput = document.querySelector(ZIP_CONFIG.selectors.zipInput);
  const fileSizeDisplay = document.querySelector(ZIP_CONFIG.selectors.zipFileSize);

  // Créer le fichier ZIP
  const zipFile = new File([zipResult.zipBlob], ZIP_CONFIG.zipFileName, { type: 'application/zip' });

  // Ajouter au formulaire
  const dataTransfer = new DataTransfer();
  dataTransfer.items.add(zipFile);
  zipInput.files = dataTransfer.files;

  // Mettre à jour la variable globale
  zipExists = true;

  // Mettre à jour l'affichage
  updateZipButtonStates();
  fileSizeDisplay.textContent = `${(zipResult.totalSize / 1024 / 1024).toFixed(2)} Mo`;

  // Message de succès
  const actionText = isModifying ? 'modifié' : 'créé';
  showStatusMessage(`Succès : Le fichier ZIP a été ${actionText} et ajouté au formulaire.`, 'success');

  document.querySelector(ZIP_CONFIG.selectors.submitButton)?.removeAttribute('disabled');
}

function handleDeleteZip() {

  clearExistingZip();
  updateZipButtonStates();

  showStatusMessage('Information : Le fichier ZIP a été supprimé. Les fichiers individuels restent sélectionnés.', 'info');

  // Désactiver le bouton de soumission
  document.querySelector(ZIP_CONFIG.selectors.submitButton)?.setAttribute('disabled', 'disabled');
}

// Helper: Afficher message de statut
function showStatusMessage(message, type) {
  clearStatusMessage();

  const messageDiv = document.createElement('div');
  messageDiv.className = ZIP_CONFIG.classes[`status${type.charAt(0).toUpperCase() + type.slice(1)}`];
  messageDiv.textContent = message;

  document.querySelector(ZIP_CONFIG.selectors.createButton).insertAdjacentElement('afterend', messageDiv);
}

// Helper: Nettoyer message de statut
function clearStatusMessage() {
  const statusMessage = document.querySelector(ZIP_CONFIG.selectors.filesStatus);
  statusMessage?.remove();
}

function disableCreateButton() {
  document.querySelector(ZIP_CONFIG.selectors.createButton).disabled = true;
}

function enableCreateButton() {
  document.querySelector(ZIP_CONFIG.selectors.createButton).disabled = false;
}

// Fonction pour nettoyer les fichiers sauvegardés des onduleurs supprimés
function cleanupOnduleurFiles() {
  const activeOnduleurs = getActiveOnduleurList();
  const activeCount = activeOnduleurs.length;

  // Identifier les fichiers onduleur à supprimer
  const filesToRemove = Object.keys(savedFileData).filter(key => {
    if (!key.startsWith('fichier-onduleur-')) return false;

    const fileNumber = parseInt(key.replace('fichier-onduleur-', ''));
    return fileNumber > activeCount;
  });

  // Supprimer les fichiers orphelins
  filesToRemove.forEach(key => {
    delete savedFileData[key];
  });

  // Réorganiser les fichiers restants pour éviter les "trous"
  const remainingOnduleurFiles = Object.keys(savedFileData)
    .filter(key => key.startsWith('fichier-onduleur-'))
    .sort((a, b) => {
      const numA = parseInt(a.replace('fichier-onduleur-', ''));
      const numB = parseInt(b.replace('fichier-onduleur-', ''));
      return numA - numB;
    });

  // Créer un nouveau mapping continu
  const newFileData = {};
  Object.keys(savedFileData).forEach(key => {
    if (!key.startsWith('fichier-onduleur-')) {
      newFileData[key] = savedFileData[key];
    }
  });

  // Réassigner les fichiers onduleur avec une numérotation continue
  remainingOnduleurFiles.forEach((oldKey, index) => {
    const newKey = `fichier-onduleur-${index + 1}`;
    newFileData[newKey] = savedFileData[oldKey];
  });

  savedFileData = newFileData;
}

// Exposer la fonction pour qu'elle soit accessible depuis index.js
window.cleanupOnduleurFiles = cleanupOnduleurFiles;

function setupOnduleurChangeListeners() {
  // 1. Ajouter un observateur pour surveiller les ajouts/suppressions d'onduleurs
  const onduleursContainer = document.querySelector('.js-blocs-onduleur');
  if (onduleursContainer) {
    const observer = new MutationObserver(function (mutations) {
      setTimeout(function () {
        cleanupOnduleurFiles(); // Nettoyer les fichiers avant de recréer l'interface
        setupFileUploads();
        setupZipHandlers();
        // updateZipButtonStates() est déjà appelé dans setupFileUploads()
      }, 100);
    });

    observer.observe(onduleursContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  // 2. Écouter le bouton d'ajout d'onduleur
  document.querySelector('.js-add-bloc[data-type="onduleur"]')?.addEventListener('click', function () {
    setTimeout(function () {
      setupFileUploads();
      setupZipHandlers();
      // updateZipButtonStates() est déjà appelé dans setupFileUploads()
    }, 200);
  });

  // 3. Écouter les clics sur les boutons de suppression (existants et futurs)
  document.addEventListener('click', function (e) {
    if (e.target && (
      e.target.classList.contains('js-delete-onduleur') ||
      e.target.classList.contains('js-remove-bloc') ||
      (e.target.closest('.js-delete-onduleur') || e.target.closest('.js-remove-bloc'))
    )) {
      setTimeout(function () {
        setupFileUploads();
        setupZipHandlers();
        // updateZipButtonStates() est déjà appelé dans setupFileUploads()
      }, 200);
    }
  });

  // 4. Écouter les changements de statut (radio onduleur oui/non)
  const onduleurRadios = document.querySelectorAll('input[name="onduleur"]');
  onduleurRadios.forEach(radio => {
    radio.addEventListener('change', function () {

      // Si on désactive les onduleurs, nettoyer les fichiers sauvegardés des onduleurs
      if (!document.getElementById('onduleur-oui').checked) {
        Object.keys(savedFileData).forEach(key => {
          if (key.includes('onduleur')) {
            delete savedFileData[key];
          }
        });
      }

      setTimeout(function () {
        setupFileUploads();
        setupZipHandlers();
        // updateZipButtonStates() est déjà appelé dans setupFileUploads()
      }, 100);
    });
  });
}

// Initialize everything when step 6 is reached
function initializeFileManager() {
  const step6 = document.getElementById('etape-6');
  if (!step6 || window.getComputedStyle(step6).display === 'none') return;

  // Create a container for file uploads if it doesn't exist
  let fileContainer = document.querySelector('.js-fichiers-container');
  if (!fileContainer) {
    fileContainer = document.createElement('div');
    fileContainer.className = 'js-fichiers-container';

    const fileSection = document.createElement('div');
    fileSection.className = 'bloc-section';
    fileSection.innerHTML = '<h3 class="h4">Fichiers à joindre</h3>';
    fileSection.appendChild(fileContainer);

    // Add the section to step 6
    step6.appendChild(fileSection);
  }

  // Add ZIP creation and deletion buttons if they don't exist
  if (!document.querySelector('.js-create-zip')) {
    const zipButtonsContainer = document.createElement('div');
    zipButtonsContainer.className = 'zip-buttons-container';

    // Create ZIP button
    const createZipButton = document.createElement('button');
    createZipButton.type = 'button';
    createZipButton.className = 'button js-create-zip';
    createZipButton.textContent = 'Créer le fichier ZIP';

    // ZIP summary section
    const zipSummary = document.createElement('div');
    zipSummary.id = 'zip-summary';
    zipSummary.style.display = 'none';
    zipSummary.innerHTML = `
      <p class="h4">Récapitulatif du fichier ZIP</p>
      <p>Fichiers inclus&nbsp;:</p>
      <ul id="zip-file-list"></ul>
      <p>Taille totale&nbsp;: <span id="zip-file-size"></span></p>
    `;

    // Delete ZIP button (after summary)
    const deleteZipButton = document.createElement('button');
    deleteZipButton.type = 'button';
    deleteZipButton.className = 'button js-delete-zip delete-zip-button';
    deleteZipButton.textContent = 'Supprimer le ZIP';
    deleteZipButton.style.display = 'none'; // Hide initially

    zipButtonsContainer.appendChild(createZipButton);
    zipButtonsContainer.appendChild(zipSummary);
    zipButtonsContainer.appendChild(deleteZipButton);

    // Add after the file container
    fileContainer.parentNode.insertBefore(zipButtonsContainer, fileContainer.nextSibling);
  }

  // Setup everything
  setupFileUploads();
  setupZipHandlers();
  setupOnduleurChangeListeners();

  // Update button states in case ZIP already exists
  updateZipButtonStates();
}

document.addEventListener('DOMContentLoaded', function () {
  // Ne pas initialiser immédiatement, attendre la navigation vers l'étape 6

  // 1. Détection des boutons de navigation entre étapes
  const navButtons = document.querySelectorAll('.btn-nav, [data-step-next], [data-step-prev]');
  navButtons.forEach(button => {
    button.addEventListener('click', function () {
      // Si on navigue vers une étape précédente et qu'un ZIP existe, le supprimer
      if (button.hasAttribute('data-step-prev') && zipExists) {
        clearExistingZip();
        showStatusMessage('', '');
      }

      // Attendre que le DOM soit mis à jour après le changement d'étape
      setTimeout(function () {
        const step6 = document.getElementById('etape-6');
        if (step6 && window.getComputedStyle(step6).display === 'block') {
          initializeFileManager();
          // Force update of button states when navigating back to step 6
          updateZipButtonStates();
        }
      }, 300);
    });
  });

  // 2. Observer les changements d'affichage des étapes
  const step6 = document.getElementById('etape-6');
  if (step6) {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'style' &&
          window.getComputedStyle(step6).display === 'block') {
          initializeFileManager();
          // Force update of button states when step 6 becomes visible
          updateZipButtonStates();
        }
      });
    });

    observer.observe(step6, { attributes: true, attributeFilter: ['style'] });
  }

  // 3. Vérifier si nous sommes déjà à l'étape 6 (cas de rechargement de page)
  if (step6 && window.getComputedStyle(step6).display === 'block') {
    initializeFileManager();
    // Force update of button states on page reload
    updateZipButtonStates();
  }

  // 4. Écouter les changements de statut des onduleurs
  const onduleurRadios = document.querySelectorAll('input[name="onduleur"]');
  onduleurRadios.forEach(radio => {
    radio.addEventListener('change', function () {
      // Si nous sommes à l'étape 6, mettre à jour les fichiers
      if (step6 && window.getComputedStyle(step6).display === 'block') {
        initializeFileManager();
      }
    });
  });
});

document.getElementById('sefcoForm').addEventListener('submit', function (event) {
  // Vérifier si un fichier ZIP a été créé
  const zipInput = document.querySelector('#fj-fichier-1');
  const fichiersContainer = document.querySelector('.js-fichiers-container');
  const fileInputs = fichiersContainer.querySelectorAll('input[type="file"]');
  const isAllFilesFull = Array.from(fileInputs).every(input => input.files.length > 0);

  //valider que tout les champs de fileInputs sont remplis
  console.log("isAllFilesFull", isAllFilesFull)
  if (!isAllFilesFull) {
    createError(event, 'Erreur : Tous les champs fichiers doivent être remplis avant de soumettre le formulaire. Si vous avez déjà créé un ZIP, veuillez le supprimer et en créer un nouveau après avoir rempli tous les champs.');
  }

  if (!zipInput.files.length) {
    createError(event, 'Erreur : Vous devez créer un fichier ZIP avant de soumettre le formulaire.');
  }
});

function createError(event, message) {
 // Empêcher l'envoi du formulaire de manière définitive
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      // Créer le conteneur d'erreurs s'il n'existe pas déjà
      let erreurContainer = document.querySelector('.hq-messages-erreurs');
      if (!erreurContainer) {
          erreurContainer = document.createElement('div');
          erreurContainer.className = 'hq-messages-erreurs';
          erreurContainer.innerHTML = '<ul></ul>';
          document.querySelector('#etape-6').insertBefore(erreurContainer, document.querySelector('#etape-6').firstChild);
      }

      // Vider le conteneur d'erreurs existant
      const ulContainer = erreurContainer.querySelector('ul');
      ulContainer.innerHTML = '';

      // Créer et ajouter le message d'erreur dans le style HQ
      const errorLi = document.createElement('li');
      errorLi.setAttribute('data-field', 'fichier-zip');
      const errorLink = document.createElement('a');
      errorLink.href = 'javascript: void(0);';
      errorLink.className = 'hq-error';
      errorLink.textContent = message;
      errorLink.onclick = function () {
          document.querySelector('.js-create-zip').scrollIntoView({ behavior: 'smooth', block: 'center' });
          document.querySelector('.js-create-zip').focus();
      };

      errorLi.appendChild(errorLink);
      ulContainer.appendChild(errorLi);

      // Afficher le conteneur d'erreurs
      erreurContainer.style.display = 'block';

      // Faire défiler jusqu'au message d'erreur
      erreurContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });

      return false;
}

// Ajouter cette fonction
function validateFileTypes() {
  const fileInputs = document.querySelectorAll(ZIP_CONFIG.selectors.fileInputs);
  const invalidFiles = [];
  const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.bmp', '.tiff'];

  fileInputs.forEach(input => {
    const file = input.files[0];
    if (!file) return;

    const fileName = file.name.toLowerCase();
    const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));

    if (!hasValidExtension) {
      const label = input.previousElementSibling?.textContent || 'Fichier inconnu';
      invalidFiles.push({
        name: file.name,
        label: label.trim()
      });
    }
  });

  if (invalidFiles.length > 0) {
    const fileList = invalidFiles.map(f => `${f.label}: ${f.name}`).join(', ');
    return {
      isValid: false,
      errorMessage: `Erreur : Types de fichiers non autorisés détectés. Seuls les formats PDF, JPG, PNG, BMP et TIFF sont acceptés. Fichiers invalides: ${fileList}`
    };
  }

  return { isValid: true };
}
